import {
    CLOSE_WHATSAPP_CHAT,
    TOGGLE_WHATSAPP_CHAT,
    UPDATE_PATIENT_WHATSAPP_INFO
} from "../actions/ActionTypes"
import initialState from "./InitialState"

export const WhatsAppChatContextReducer = (state = initialState.whatsAppChatContext, action: any) => {
    switch (action.type) {
        case UPDATE_PATIENT_WHATSAPP_INFO:
            return { ...state, patientInfo: action.patientInfo, chatWindowVisible: true }
        case CLOSE_WHATSAPP_CHAT:
            return { ...state, patientInfo: null, chatWindowVisible: false, chatWindowCollapsed: false }
        case TOGGLE_WHATSAPP_CHAT:
            return { ...state, chatWindowCollapsed: !state.chatWindowCollapsed }
        default:
            return state;
    }
}